// components/Events/ShieldMitigationEvent.tsx

import React, { useContext } from 'react';
import { BaseRendererProps } from './eventRenderers';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTurnUp } from '@fortawesome/free-solid-svg-icons';
import { getUniversalSourceIcon } from './StatChangeEvent';
import './ShieldMitigationEvent.css';

const ShieldMitigationEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);
  const { itemImages, runes, shieldIcon } = gameWideAssets;

  const details = log.details;
  const {
    championName,
    shieldStat,
    shieldSource,
    damageAbsorbed,
  } = details;

  // Determine the shield icon based on shieldStat
  let shieldIconElement = null;
  switch (shieldStat) {
    case 'shield':
    case 'magicShield':
    case 'physicalShield':
      shieldIconElement = (
        <div className="shield-icon-container">
          <img
            src={shieldIcon}
            alt={`${shieldStat} Icon`}
            className={`shield-icon-image ${shieldStat}`}
          />
        </div>
      );
      break;
    default:
      // Fallback icon
      shieldIconElement = (
        <div className="shield-icon-container">
          <span className="shield-icon-default"></span>
        </div>
      );
      break;
  }

  // Use the universal image fetching function
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: details.sourceType || 'Ability', // Assume ability if not specified
      imageState: shieldSource,
      sourceName: shieldSource,
      championName: championName,
    },
    gameWideAssets,
    championsAssets
  );

  // Display the amount of damage absorbed
  const damageDisplay = `-${Math.abs(damageAbsorbed).toFixed(0)}`;

  // Tooltip text for additional information
  const tooltipText = `Shield absorbed ${damageDisplay} damage`;

  return (
    <div className="shield-mitigation-event" title={tooltipText}>
      <div className="shield-mitigation-amount-wrapper">
        {shieldIconElement}
        <span className="shield-mitigation-amount">{damageDisplay}</span>
      </div>
      {sourceIcon && (
        <div className="shield-mitigation-source-wrapper">
          <FontAwesomeIcon icon={faTurnUp} className="fa-turn-up" />
          {sourceIcon}
        </div>
      )}
    </div>
  );
};

export default ShieldMitigationEvent;
